import { L10nProvider } from 'angular-l10n';

/**
 * L10n translation providers array use to get the path to get the json assets.
 * This array should be used on a regular configuration of the l10n-angular
 * module import:
 *
 * @example
 * ```angular2
 * import { L10N_TRANSLATION_PROVIDERS } from '@cbre/stacking-plan';
 * const l10nConfig: L10nConfig = {
 *  translation: {
 *    providers: [...L10N_TRANSLATION_PROVIDERS, { type: ProviderType.Static, prefix: './assets/locale-' }],
 *    caching: true,
 *    version: '8.0.0',
 *    rollbackOnError: true,
 *    composedKeySeparator: '.',
 *    missingValue: 'Missing Value',
 *  },
 * };
 * ...
 *  @NgModule({
 *    imports: [
 *      LocalizationModule.forChild(l10nConfig),
 *    ],
 *  })
 *  export class MyFeatureModule{}
 * ```
 */
export const L10N_REPORTS_TRANSLATION_PROVIDERS: Array<L10nProvider> = [
  {
    name: 'ppt',
    asset: 'assets/reports-locales/locale',
  },
];
